import { Route, Switch, useHistory, useParams, useRouteMatch } from "react-router-dom";
import { ArchiverBrowseFolderPage } from "@newPages/archiver/ArchiverBrowseFolderPage";
import { ArchiverFileDetailPage } from "@newPages/archiver/ArchiverFileDetailPage";
import { tryBigIntParse } from "@newRoutes/paramValidators";
import { FolderContext, useFolderContext } from "@newHooks/context/folder/folder.context";

function ArchiverRouteInner() {
  const history = useHistory();
  const match = useRouteMatch();
  const { folderId: folderIdStr } = useParams<{ folderId: string }>();
  const { folderIds: parentFolderIds } = useFolderContext();

  const folderIds = folderIdStr ? parentFolderIds.concat(tryBigIntParse(folderIdStr, history)) : parentFolderIds;
  const currentFolderId = folderIds.length > 0 ? folderIds.slice(-1)[0] : undefined;

  return (
    <FolderContext.Provider value={{ folderIds, currentFolderId }}>
      <Switch>
        <Route exact path={`${match.url}/files/:fileId(\\d+)`} render={() => <ArchiverFileDetailPage />} />
        <Route path={`${match.url}/:folderId(\\d+)`} render={() => <ArchiverRouteInner />} />
        <Route exact path={match.url} render={() => <ArchiverBrowseFolderPage />} />
      </Switch>
    </FolderContext.Provider>
  );
}

export function ArchiverRoute() {
  const match = useRouteMatch();

  return (
    <FolderContext.Provider value={{ folderIds: [] }}>
      <Switch>
        <Route path={match.url} render={() => <ArchiverRouteInner />} />
      </Switch>
    </FolderContext.Provider>
  );
}
